import { FormFieldWidget, ModelFieldType, SPI, ViewType, Widget, WidgetSubjection } from '@kunlun/dependencies';
import { FormM2mMultiAfterSalesRefundsFieldWidget } from '../AfterSalesRefunds';

/**
 *  经销工作台 -> 收货单 -> 创建、编辑页面
 * */

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Form,
    ttype: ModelFieldType.ManyToMany,
    widget: 'Table',
    name: 'initialProxySaleSkus',
    model: ['deli.aries.merchant.DeliAriesMerchantBrandStoreReverseOrderCreate', 'deli.aries.merchant.DeliAriesMerchantBrandStoreReverseOrderEdit'],
    multi: true
  })
)
export class FormM2mMultiBuyerAfterSalesRefundsFieldWidget extends FormM2mMultiAfterSalesRefundsFieldWidget {
  @Widget.Reactive()
  protected get actionBarActions() {
    return {
      showExportAction: false,
      showImportAction: false,
      showAddRowAction: false,
      showBatchUpdateAction: true,
      showBatchDeleteAction: true,
      showPriceSourceAction: false,
      showQuickAddAction: false,
      showERPCodeFilterInput: true
    };
  }

  @Widget.Reactive()
  protected get originalEditTypeOptions(): {
    label: string;
    value: any;
  }[] {
    return [
      { label: '售后原因', value: 'reason' }
    ];
  }

  @Widget.Reactive()
  protected get showReverseNum() {
    return true;
  }


  @Widget.BehaviorSubContext(Symbol('deleteRow'), {
    data: ''
  })
  protected deleteEvent !: WidgetSubjection<{
    data: string
  }>;

  @Widget.Reactive()
  protected ERPCodeFilterString = '';

  @Widget.Method()
  protected ERPCodeFilterStringChange(event) {
    this.ERPCodeFilterString = event.target.value;
  }

  @Widget.Method()
  protected getGqlMutationName() {
    const map = {
      'deli.aries.merchant.DeliAriesMerchantBrandStoreReverseOrderCreate': 'deliAriesMerchantBrandStoreReverseOrderCreateMutation',
      'deli.aries.merchant.DeliAriesMerchantBrandStoreReverseOrderEdit': 'deliAriesMerchantBrandStoreReverseOrderEditMutation'
    } as const;
    const name = map[this.field.model];
    if (!name) throw new Error('name not found');
    return name;
  }

  @Widget.Method()
  protected getGqlQueryName() {
    const map = {
      'deli.aries.merchant.DeliAriesMerchantBrandStoreReverseOrderCreate': 'deliAriesMerchantBrandStoreReverseOrderCreateQuery',
      'deli.aries.merchant.DeliAriesMerchantBrandStoreReverseOrderEdit': 'deliAriesMerchantBrandStoreReverseOrderEditQuery'
    } as const;
    const name = map[this.field.model];
    if (!name) throw new Error('name not found');
    return name;
  }

  @Widget.Reactive()
  protected get addRowExpendCondition() {
    return `sellerId: ${this.formData.sellerId}`;
  }

  @Widget.Reactive()
  protected get showSpecificationTip() {
    return false;
  }

  @Widget.Reactive()
  protected get editApplyRefundUnitPrice() {
    return false;
  }

  @Widget.Method()
  async changeReasonAfter() {
    this.confirmReturnDetail();
  }

  @Widget.Method()
  protected deleteRow(code) {
    this.deleteEvent.subject.next({
      data: code
    });
  }

  async itemDetailConstructMirrorByReturnMoneyGoodsV2(create, copyRows) {
    create.code = this.formData.code;
    return super.itemDetailConstructMirrorByReturnMoneyGoodsV2(create, copyRows);
  }
}
